import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash"
export default class extends Controller {
  static values = { isPersisting: Boolean };

  connect() {
    setTimeout(() => {
      this.element.dataset.active = true;
    }, 100);
    if (this.isPersistingValue) {
      return;
    }
    setTimeout(() => {
      this.close();
    }, 3000);
  }

  close() {
    this.element.dataset.active = false;
    setTimeout(() => {
      this.element.remove();
    }, 500);
  }
}
